export default "__VITE_ASSET__28024819__"